<div class="grid grid-cols-1 gap-4">
    <app-communication-input (send)="saveComment($event)"></app-communication-input>
    <app-communication-comment
        class="max-h-screen overflow-y-scroll"
        [comments]="comments"
        [users]="users"
        (send)="saveComment($event)"
        *ngIf="comments.length"
    ></app-communication-comment>
    <div
        *ngIf="!(comments.length)"
        class="text-center bg-accent-50 py-6 text-accent-400 rounded font-bold"
    >
        Aucun commentaires pour l'instant
    </div>
</div>
